import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import Link from '../Link/Link';
import s from './Dashboard.css';

// Icons
import IconReservas from '/public/SiteIcons/calendar4.svg';
import IconChevron from '/public/SiteIcons/chevron-right.svg';
import IconGrid from '/public/SiteIcons/grid.svg';
import IconPanel from '/public/SiteIcons/home.svg';
import IconInbox from '/public/SiteIcons/message.svg';
import IconCuenta from '/public/SiteIcons/settings.svg';
import IconPerfil from '/public/SiteIcons/user.svg';

// Help illustration
import { useSelector } from 'react-redux';
import PersonajeLaptop from '/public/SiteImages/personaje-laptop-parado.svg';

const DashboardSideNav = () => {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/dashboard';
  const userData = useSelector((state) => state.account.data);
  const isVerified = userData?.profileId;

  const NAV_ITEMS = [
    { label: 'Panel', to: '/dashboard', icon: IconGrid },
    { label: 'Bandeja de entrada', to: '/inbox', icon: IconInbox },
    { label: 'Mis alojamientos', to: '/rooms', icon: IconPanel },
    { label: 'Reservas', to: '/trips/current', icon: IconReservas },
    /* { label: 'Mensajes', to: '/user/reviews/about-you', icon: IconResenas }, */
    { label: 'Perfil', to: `/users/show/${isVerified}`, icon: IconPerfil },
    { label: 'Cuenta', to: '/users/security', icon: IconCuenta },
  ];

  return (
    <div className={s.sideNavWrapper}>
      {/* Lista de ítems del menú */}
      <nav className={s.sideNavList}>
        {NAV_ITEMS.map(({ label, to, icon }) => {
          const isActive = currentPath === to
            || (to === '/trips/current' && currentPath.startsWith('/trips/'))
            || (to !== '/dashboard' && currentPath.startsWith(`${to}/`));
          return (
            <Link
              key={to}
              to={to}
              className={cx(s.sideNavItem, { [s.sideNavItemActive]: isActive })}
            >
              <span className={s.sideNavIcon}>
                <img src={icon} alt={label} className={s.sideNavIconImg} />
              </span>
              <span className={s.sideNavLabel}>{label}</span>
            </Link>
          );
        })}
      </nav>

      {/* Sección ¿Necesitas ayuda? al final */}
      <Link to="/help" className={s.helpSection}>
        <div className={s.helpIllustration}>
          <img src={PersonajeLaptop} alt="Ayuda" className={s.helpImage} />
        </div>
        <div className={s.helpContent}>
          <p className={s.helpTitle}>¿Necesitas ayuda?</p>
          <p className={s.helpText}>Visita nuestras preguntas frecuentes o contáctanos.</p>
        </div>
        <img src={IconChevron} alt="" className={s.helpChevron} />
      </Link>
    </div>
  );
};

export default withStyles(s)(DashboardSideNav);
